import { createAnimatedLottie } from '../Lottie';

export const AnimatedAgentIcon = createAnimatedLottie({
    dark: () => import('./assets/icon-dark.json'),
    light: () => import('./assets/icon-light.json'),
});
